import { useAutoSync } from '@/hooks/useAutoSync';

export function AutoSyncManager() {
  useAutoSync();
  return null; // Componente invisible que corre en el fondo
}
